import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class BringozTimeSelectFormComponent implements IController {
  selectedTime: any;
  ticksInMinutes: any;
  min: any;
  max: any;
  ngPlaceholder: any;
  name:string;
  isRequired: any;
  isDisabled: any;
  onSelect: Function;

  defaultTicks: number = 30;
  timeFormat: any;
  hourFormat: any;
  searchTerm: any;
  timeOptions: any;

  constructor(private $filter, private splitService, private moment) {
  }

  $onInit() {
    this.timeFormat = this.splitService.getDateAndTimeConfig().time;
    this.hourFormat = this.splitService.getDateAndTimeConfig().hour;
    if(!this.name){
      this.name = "bringozTimeSelectForm"
    }
  }

  $onChanges(changes) {
    // if (changes.selectedTime ||
    //   (changes.min && !changes.min.isFirstChange()) ||
    //   (changes.max && !changes.max.isFirstChange())) {
    //   this.setAllTimeOptions();
    // }

    if (changes.selectedTime) {
      this.setSelectedTimeOptions();
    }
  }

  onOpen() {
    this.setAllTimeOptions();
  }

  onClose(selectedTime) {
    this.setSelectedTimeOptions();
    this.onSelect({date: selectedTime});
  }

  getSelectedTimeText() {
    return this.$filter('bringozTime')({optionRef: this.selectedTime}, 'optionRef', this.ngPlaceholder);
  }

  filterOptions() {
    return  (option) => {

      if (!this.searchTerm) {
        return true;
      }

      let hour = _.toString(this.moment(option).format(this.hourFormat));
      let minute = _.toString(this.moment(option).format('mm'));

      let colonIndex = this.searchTerm.indexOf(':');
      let queryHour = colonIndex > -1 ? this.searchTerm.substring(0, colonIndex) : this.searchTerm;
      let queryMin = colonIndex > -1 ? this.searchTerm.substring(colonIndex + 1, this.searchTerm.length) : undefined;
      let hasOptionInTicks = (queryMin % (this.ticksInMinutes || this.defaultTicks)) === 0;

      queryHour = _.toString(queryHour).padStart(2, '0');

      if (!!queryMin) {
        queryMin = _.toString(queryMin).padStart(2, '0');
      }

      if (!queryMin) {
        return hour === queryHour;
      } else {
        if (!hasOptionInTicks) {
          return hour === queryHour;
        } else {
          return (hour === queryHour) && (minute === queryMin);
        }
      }

    }
  }

  setAllTimeOptions() {
    let timeOptions = [];
    let is12HourClock = this.timeFormat === 'h:mm A';
    let hourOptions = this.getHoursByType();
    let minOptions = this.getMinutes();
    let isValidTime = (new Date(this.selectedTime)).getTime() > 0;
    let selectedTime = isValidTime ? this.selectedTime : undefined;

    let min = this.min || this.moment(this.selectedTime).startOf('day').valueOf();
    let max = this.max || this.moment(this.selectedTime).endOf('day').valueOf();

    _.forEach(hourOptions,  (h) => {
      var options = _.chain(minOptions)
        .map((m) => {
          let time = this.moment(this.selectedTime).set({'hour': h, 'minute': m, 'second': 0, 'millisecond': 0}).valueOf();
          if (this.moment(time).isBetween(min, max, null, [])) {
            return time;
          }
        })
        .compact()
        .value();
      timeOptions = timeOptions.concat(options);
    });
    this.timeOptions = timeOptions;
  }

  setSelectedTimeOptions() {
    this.timeOptions = this.selectedTime ? [this.selectedTime] : [];
  }

  private getHoursByType() {
    let hours = [];
    _.times(24,  (i) => {
      hours.push(i);
    });
    return hours;
  }

   private getMinutes() {
    let ticks = this.ticksInMinutes || this.defaultTicks;
    let times = Math.round((60 / ticks));
    let counter;
    let minutes = [];

    _.times(times,  (i) => {
      counter = _.isUndefined(counter) ? 0 : (counter + ticks);
      minutes.push(counter);
    });
    return minutes;
  }

}

angular
  .module('bringoz.admin.commons')
  .component('bringozTimeSelectForm', {
    require: {
      form: '?^form'
    },
    bindings: {
      selectedTime: '<',
      ticksInMinutes: '<',
      min: '<?',
      max: '<?',
      ngPlaceholder: '<?',
      onSelect: '&',
      name: '<?',
      isRequired: '<',
      isDisabled: '<'
    },
    templateUrl: 'app/modules/commons/components/bringoz-time-select/bringoz-time-select.html',
    controller: BringozTimeSelectFormComponent
  });
